module.exports = require('./helpers/bundle-url').getBundleURL('dwYZa') + "storm.f2f1255d.png";